<template>
    <div class="wrapper">
        <dash-header></dash-header>
        <sidebar></sidebar>
        <div class="content-wrapper">
            <!-- Content Header (Page header) -->
            <section class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <h1 class="m-0 title">Add Card</h1>
                        </div><!-- /.col -->
                        <div class="col-sm-6">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item"><router-link to="/dash">Home</router-link></li>
                                <li class="breadcrumb-item"><router-link to="/bank-account">Bank Account</router-link>
                                </li>
                                <li class="breadcrumb-item active">Add Card</li>
                            </ol>
                        </div><!-- /.col -->
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </section>
            <!-- /.content-header -->

            <section class="content">
                <div class="container-fluid">
                    <form action="" @submit.prevent="tambahDataBank">
                        <div class="form-group">
                            <label for="owner_name">Owner Name</label>
                            <input type="text" v-model="owner_name" class="form-control" id="owner_name"
                                name="owner_name">
                            <div v-if="submitted && required.owner" class="text-danger">
                                Owner Name Required
                            </div>
                            <div v-if="submitted && validation.owner_name" class="text-danger">
                                {{ validation.owner_name[0] }}
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="account_number">Account Number</label>
                            <input type="number" v-on:keypress="NumbersOnly" v-model="account_number"
                                class="form-control" id="account_number" name="account_number">
                            <div v-if="submitted && required.account" class="text-danger">
                                Account Number Required
                            </div>
                            <div v-if="submitted && validation.account_number" class="text-danger">
                                {{ validation.account_number[0] }}
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="bank_name">Bank Name</label>
                            <select class="form-select" v-model="bank_name" id="bank_name" name="bank_name">
                                <option v-for="(list, index) in bank" :key="index" :value="list.name">{{ list.name }}
                                </option>
                            </select>
                            <div v-if="submitted && required.bank" class="text-danger">
                                Bank Name Required
                            </div>
                            <div v-if="submitted && validation.bank_name" class="text-danger">
                                {{ validation.bank_name[0] }}
                            </div>
                            <!-- <input type="text" v-model="bank_name" class="form-control" id="bank_name" name="bank_name"> -->
                        </div>
                        <div class="form-group">
                            <label for="branch_name">Branch Name</label>
                            <input type="text" v-model="branch_name" class="form-control" id="branch_name"
                                name="branch_name">
                            <div v-if="submitted && required.branch" class="text-danger">
                                Branch Name Required
                            </div>
                            <div v-if="submitted && validation.branch_name" class="text-danger">
                                {{ validation.branch_name[0] }}
                            </div>
                        </div>
                        <router-link to="/bank-account" class="btn btn-secondary m-2">Cancel</router-link>
                        <button type="submit" class="btn btn_red btn_bank" id="btn_bank">Save</button>
                    </form>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import DashHeader from "../layouts/Header.vue";
// import DashFooter from "../layouts/Footer.vue";
import { dragscroll } from "vue-dragscroll";
import Sidebar from "../layouts/Sidebar.vue";
import axios from "axios"
import swal from 'sweetalert'

export default {
    name: "AddBank",
    directives: {
        dragscroll,
    },
    components: {
        DashHeader,
        // DashFooter,
        Sidebar,
    },
    data() {
        return {
            user_id: localStorage.getItem('user_id'),
            investor_id: this.user_id,
            bank_name: "",
            branch_name: "",
            owner_name: "",
            account_number: "",
            submitted: false,
            dataset: 0,
            accountbank: [],
            bank: [],
            validation: [],
            required: {
                owner: false,
                account: false,
                bank: false,
                branch: false
            },
        }
    },
    async mounted() {
        window.scrollTo(0, 0)

        await axios.get(`investor/bank`)
            .then((response) => {
                // console.log("List Bank 1", response.data.data)
                this.accountbank = response.data.data
            }).catch(() => {
                // console.log("Error List Bank", err.response)
            })

        await axios.get(`bank/`)
            .then((response) => {
                // console.log("All Bank Name", response.data.data)
                this.bank = response.data.data
            }).catch(() => {
                // console.log("Error All Bank", err.response)
            })
    },
    methods: {
        NumbersOnly(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        tambahDataBank() {
            this.submitted = true
            document.getElementById("btn_bank").disabled = true;
            let k = 0
            if (this.accountbank.length == 0) {
                this.dataset = 1
            }
            for (let i = 0; i < this.accountbank.length; i++) {
                let data = this.accountbank[k].account_number
                // console.log(data)
                if (data == this.account_number) {
                    this.dataset = 0
                    break
                }
                else if (data != this.account_number) {
                    this.dataset = 1
                }
                k++
            }
            // console.log(this.dataset)
            if (this.dataset == 1) {
                // console.log(this.$user_id)
                let data = new FormData()
                data.append('investor_id', this.user_id)
                data.append('bank_name', this.bank_name)
                data.append('branch_name', this.branch_name)
                data.append('owner_name', this.owner_name)
                data.append('account_number', this.account_number)

                // axios.post(`investor/bank/`, data)
                // .then((response) => {
                //     console.log(response.data.status);
                //     if(response.data.status == 201) {
                //         this.bank_name = ''
                //         this.branch_name = ''
                //         this.owner_name = ''
                //         this.account_number = ''
                //         document.getElementById("btn_bank").disabled = false
                //         swal('Congratulation!!!', 'Bank data added successfully.', 'success', {
                //             button: "OK"
                //         })

                //         this.$router.push('/bank-account')

                //     } else {
                //         document.getElementById("btn_bank").disabled = false
                //     }
                // }).catch((error) => {
                //     console.log(error.response)
                //     this.validation = error.response.data.data
                //     // this.submitted = false
                //     document.getElementById("btn_bank").disabled = false
                //     // event.preventDefault(),            
                //     // event.target.reset()
                // })
                if (this.owner_name == '' || this.account_number == '' || this.bank_name == '' || this.branch_name == '') {
                    if (this.owner_name !== '') {
                        this.required.owner = false
                    } else {
                        this.required.owner = true
                    }
                    if (this.account_number !== '') {
                        this.required.account = false
                    } else {
                        this.required.account = true
                    }
                    if (this.bank_name !== '') {
                        this.required.bank = false
                    } else {
                        this.required.bank = true
                    }
                    if (this.branch_name !== '') {
                        this.required.branch = false
                    } else {
                        this.required.branch = true
                    }
                    document.getElementById("btn_bank").disabled = false
                } else {
                    swal("Are You Sure?", 'Make sure your bank Account is Active. You can only change this by contacting our Customer Services.', "warning", {
                        buttons: ["Cancel", "Yes, Add it!"],
                        className: "text-center"
                    }).then((confirm) => {
                        if (confirm) {
                            axios.post(`investor/bank/`, data)
                                .then((response) => {
                                    // console.log(response.data.status);
                                    if (response.data.status == 201) {
                                        this.bank_name = ''
                                        this.branch_name = ''
                                        this.owner_name = ''
                                        this.account_number = ''
                                        document.getElementById("btn_bank").disabled = false
                                        swal('Congratulation!!!', 'Bank data added successfully.', 'success', {
                                            button: "OK"
                                        })

                                        this.$router.push('/bank-account')

                                    } else {
                                        document.getElementById("btn_bank").disabled = false
                                    }
                                }).catch((error) => {
                                    // console.log(error.response)
                                    this.validation = error.response.data.data
                                    // this.submitted = false
                                    document.getElementById("btn_bank").disabled = false
                                    // event.preventDefault(),            
                                    // event.target.reset()
                                })
                        } else {
                            document.getElementById("btn_bank").disabled = false
                            if (swal.close()) {
                                console.log("Cancel")
                            }
                        }
                    })
                }


            } else {
                // event.preventDefault(),    
                // event.target.reset()
                // this.bank_name = 
                // this.branch_name = ''
                // this.owner_name = ''
                // this.account_number = ''
                // this.submitted=false
                document.getElementById("btn_bank").disabled = false
                swal('Account already exists', 'Please change the account number', 'info', {
                    button: "OK"
                })
            }
        },

    }
}
</script>

<style scoped>
input.form-control {
    padding: 15px;
}

.btn_bank {
    width: 200px;
}

a.btn-secondary {
    padding: 10px;
}

.swal-text {
    text-align: center !important;
}
</style>